import React from 'react';
import classNames from 'classnames';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import DropdownMenu, { DropdownMenuItem } from '../dropdown-menu/dropdown-menu';
import Button from '../button/button';
import styles from './dropdown-button.module.scss';

interface Props {
	buttonText: string;
	onButtonClick: () => void;
	menuItems: DropdownMenuItem[];
	icon?: BringgFontIcons;
	className?: string;
	disabled?: boolean;
	mainButtonTestId?: string;
}

const DropdownButton = ({
	onButtonClick,
	menuItems,
	buttonText,
	icon,
	className,
	disabled,
	mainButtonTestId
}: Props) => {
	return (
		<div className={classNames(styles.dropdownButtonContainer, className)}>
			<Button
				className={styles.dropdownButtonAction}
				type="primary"
				onClick={onButtonClick}
				disabled={disabled}
				data-test-id={mainButtonTestId}
			>
				{buttonText}
			</Button>
			<DropdownMenu items={menuItems} placement="bottom-end">
				<Button
					className={styles.dropdownMenuButton}
					type="primary"
					icon={<BringgIcon iconName={icon ?? BringgFontIcons.Chevron} />}
					disabled={disabled}
				/>
			</DropdownMenu>
		</div>
	);
};

export default DropdownButton;
